import algoliasearch from 'algoliasearch';

import { FR } from '../../helpers/i18n';

import { API_ID, API_KEY } from './algolia-config';

const client = {};

/**
 * @param {String} [key=API_KEY]
 * @param {String} [id=API_ID]
 * @return {*}
 */
export const init = (key = API_KEY, id = API_ID) => {
  if (!client[key]) {
    client[key] = algoliasearch(id, key);
  }
  return client[key];
};

/**
 * @param {String} index
 * @param {String} [key]
 * @param {String} [id]
 * @return {Index|IndexCore}
 */
export const getClient = (key = API_KEY, id = API_ID) => init(key, id);

const getAlgoliaIndexEnvironment = () => {
  /* istanbul ignore next */
  switch (process.env.RAZZLE_ENV) {
    case 'prod':
    case 'recette':
      return process.env.RAZZLE_ENV;
    default:
      return 'preprod';
  }
};

export const getAlgoliaIndexName = (lang = FR) =>
  `${getAlgoliaIndexEnvironment()}_${lang}_lglp`;
